<template>
  <div id="menaboh">
    <div :class="{ start: step > 1 }" v-if="cart && !boxInCart">
      <div v-if="step > 1" id="menaboh-header">
        <Logo />
        <div>
          <button class="btn" @click="changeLang()">
            <div v-if="lang === 'it'">
              <svg class="icon"><use xlink:href="#icon-eng" /></svg>
            </div>
            <div v-else>
              <svg class="icon"><use xlink:href="#icon-italy" /></svg>
            </div>
          </button>
        </div>
        <button @click="reset()">
          <svg class="icon"><use xlink:href="#icon-close" /></svg>
        </button>
      </div>

      <Box v-if="step == 1" :type="type" />
      <Mood v-if="step == 2" :lang="lang" />
      <Star v-if="step == 3" :lang="lang" />
    </div>

    <div v-else-if="cart && boxInCart">
      <BoxInCart :lang="lang" />
    </div>

    <div v-else class="loading">
      <Preloader :size="90" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Box from "./components/Box.vue";
import Mood from "./components/Mood.vue";
import Star from "./components/Star.vue";
import Preloader from "./components/Preloader.vue";
import BoxInCart from "./components/BoxInCart.vue";
import Logo from "./components/Logo.vue";

export default {
  name: "Menaboh",
  data() {
    return {
      cart: null,
      type: "",
      boxInCart: null,
      languages: ["en", "it"],
      lang: "en",
    };
  },

  computed: {
    step: function() {
      return this.$store.state.step
        ? this.$store.state.step
        : localStorage.getItem("menaboh_step");
    },
  },

  watch: {
    cart: function(val) {
      this.boxInCart = Object.keys(val.items).some(function(k) {
        return val.items[k]["id"] === 68;
      });
    },
  },
  components: {
    Box,
    Mood,
    Star,
    Preloader,
    BoxInCart,
    Logo,
  },

  methods: {
    changeLang() {
      if (this.lang === "en") this.lang = "it";
      else this.lang = "en";
      console.log(this.lang);
    },
    fetchSettings: function() {
      const menaboh = document.getElementById("menaboh-app");
      if (menaboh) {
        const settings = JSON.stringify({
          type: menaboh.dataset.type,
          start: menaboh.dataset.start,
        });
        this.type = menaboh.dataset.type;
        return settings;
      } else {
        return null;
      }
    },
    fetchCart: function() {
      axios.get(window["wpApiSettings"].root + "wc/store/cart").then(
        (response) =>
          //console.log(response.data.items.item_data),
          (this.cart = response.data)
      );
    },

    reset: function() {
      this.$store.commit("goToStep", 1);
      document.body.classList.remove("fixed");
    },
  },

  beforeMount() {
    this.fetchSettings();
    this.fetchCart();
  },
};
</script>

<style lang="scss">
$rosa: #fff;

.loading {
  height: 100%;
  display: flex;
  align-items: center;
}

body.fixed {
  position: fixed;
  overflow: hidden;
}
.page main {
  background-image: none;
}
.btn {
  margin-top: 10 px;
}
#menaboh {
  transition: all 0.4s ease-in-out;
  height: 100%;

  > div {
    height: 100%;
  }

  .start {
    position: fixed;
    background: $rosa;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    -ms-touch-action: auto;
    touch-action: auto;
  }
}

#menaboh-header {
  position: absolute;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.5rem;
  height: 70px;

  button {
    margin-left: auto;
    svg {
      width: 28px;
      height: 28px;
    }
  }
}

#menaboh-body {
  position: absolute;
  height: 150px;
  top: 90px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

.title {
  color: #000;
  text-align: center;
  margin: 0;
  padding: 1rem 0 0 0;
}

.instruction {
  font-size: 1rem;
  margin: 0;
}

button {
  background: none;
  border: 0px;
  text-transform: uppercase;
}

.mood-buttons {
  text-align: center;
  padding: 1rem;
}
</style>
